import * as React from "react";
import { BaseFieldEditor } from "./helper";
import { FieldValueText } from "typings";
import { getOriginalImage } from "~/util/media";
import { Icon } from "office-ui-fabric-react";

export interface Props extends BaseFieldEditor
{
    value: FieldValueText;
}


class File extends React.Component<Props>
{
    render()
    {
        //TODO change file
        const path = this.props.value.value as string;
        const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
        if (allowedExtensions.exec(path))
        {
            
            return (
                <img src={getOriginalImage(path)}/>
            );
        }
        let iconName = "File";
        if (path.endsWith(".pdf"))
        {
            iconName = "PDF";
        }
        return <Icon iconName={iconName}></Icon>;
      
    }
}

export default File;


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/File.tsx